/* GM · Newsletter → Klaviyo (API client, revision 2024-10-15)
   Intercetta il submit del modulo newsletter del tema, manda il profilo a Klaviyo
   e poi lascia proseguire il submit nativo verso Shopify (modo "both")
   oppure mostra direttamente il messaggio di successo (modo "solo"). */
(function () {
  'use strict';
  var REV = '2024-10-15';

  function send(host, form) {
    var email = (form.querySelector('input[name="contact[email]"]') || {}).value || '';
    var first = (form.querySelector('input[name="contact[first_name]"]') || {}).value || '';
    email = email.trim();
    if (!email) return Promise.resolve(false);
    var attrs = { email: email, subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } } };
    if (first.trim()) attrs.first_name = first.trim();
    var body = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: host.dataset.gmSource || 'Newsletter sito',
          profile: { data: { type: 'profile', attributes: attrs } }
        },
        relationships: { list: { data: { type: 'list', id: host.dataset.gmList } } }
      }
    };
    var url = 'https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(host.dataset.gmKey);
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'revision': REV },
      body: JSON.stringify(body),
      keepalive: true
    }).then(function (r) { return r.ok; }).catch(function () { return false; });
  }

  function showSuccess(host, form) {
    form.classList.remove('has-error');
    form.classList.add('has-success');
    if (!form.querySelector('.newsletter__message--success')) {
      var p = document.createElement('p');
      p.className = 'newsletter__message newsletter__message--success';
      p.setAttribute('tabindex', '-1');
      p.textContent = host.dataset.gmSuccess || 'Grazie!';
      form.insertBefore(p, form.firstChild);
      p.focus();
    }
    form.reset();
  }

  function hook(host) {
    var form = host.querySelector('[data-newsletter-form]');
    if (!form || host.dataset.gmHooked) return;
    host.dataset.gmHooked = '1';
    host.addEventListener('submit', function (e) {
      if (form.dataset.gmKlaviyoDone) return; // secondo giro: lascia fare al tema
      if (!form.checkValidity()) return;      // la validazione nativa parla da sola
      e.preventDefault();
      e.stopImmediatePropagation();
      var btn = form.querySelector('[type="submit"]');
      if (btn) btn.disabled = true;
      send(host, form).then(function (ok) {
        if (btn) btn.disabled = false;
        if (host.dataset.gmMode === 'solo' && ok) {
          showSuccess(host, form);
          return;
        }
        form.dataset.gmKlaviyoDone = '1';
        if (form.requestSubmit) form.requestSubmit(); else form.submit();
      });
    }, true);
  }

  function init() {
    document.querySelectorAll('newsletter-component[data-gm-klaviyo]').forEach(hook);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
